import { generateGiftCardCode } from './generateGiftCardCode'

export const generateGiftCardCodes = (quantity: number, prefix?: string) => {
  const codes: string[] = []

  while (codes.length < quantity) {
    const code = generateGiftCardCode(prefix)

    if (codes.indexOf(code) === -1) {
      codes.push(code)
    }
  }

  return codes
}
